<template>
  <v-form ref="streetEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'delivery-index', params: {tab: 1}})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col  cols="12" sm="5" md="4" xl="3">
        <h1 class="mb-16">{{ street.id ? 'Редактировать улицу' : 'Создать улицу'}}</h1>
        <v-tabs v-model="tabLang">
          <v-tab>RU</v-tab>
          <v-tab>UA</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabLang">
          <v-tab-item :eager="true">
            <v-row>
              <v-col class="pb-0 mb-0">
                <v-text-field
                        v-model="street.name"
                        label="Название"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col class="pb-0 mb-0">
                <v-text-field
                        v-model="street.name_ua"
                        label="Название"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
        <v-select
                :items="areas"
                :item-text="area => area.name"
                :item-value="area => area.id"
                v-model="street.area"
                return-object
                :rules="[rules.requiredSelect]"
                required
                label="Район"
                outlined
        ></v-select>

        <v-btn :loading="loadingButton" v-if="id" @click="update">Сохранить</v-btn>
        <v-btn :loading="loadingButton" v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import StreetService from './../../../api/StreetService'
  import moment from 'moment'
  import AreaService from "../../../api/AreaService";

  export default {
    name: 'StreetEdit',
    props: {
        id: {
            default: null,
        }
    },
    components: {},
    data: () => ({
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      tabLang: '',
      valid: true,
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: v => {return !!v.id || 'Нужно заполнить'},
      },
      street: {
          name: '',
          name_ua: '',
          area: {},
      },
      loading: true,
      loadingButton: false,
      areas: [],
    }),
    mounted() {
      this.init();
      AreaService.list().then(response => {
        this.areas = response.data
      });
    },
    methods: {
      validate () {
        this.$refs.streetEditForm.validate()
        if(this.street.name == '' && this.street.name_ua != ''){
          this.tabLang = 0;
        }
        if(this.street.name != '' && this.street.name_ua == ''){
          this.tabLang = 1;
        }
      },
      init(){
        if(this.id) {
          StreetService.get(this.id)
            .then(response => {
              this.street = response.data;
              this.loading = false
            });
        }
      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }
        this.loadingButton = true;
        let formData = this.getData();

        StreetService.update(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Улица успешно обновлена';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении улицы';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      create(){
        this.validate()
        if(!this.valid){
          return false
        }
          this.loadingButton = true;
          var formData = this.getData();

          StreetService.create(formData).then(response => {
            this.snackbar = true;
            this.snackbarText = 'Улица успешно создана';
            this.snackbarColor = 'success';
            this.$router.push({ name: 'street-edit', params: { id: response.data.id } })
            this.init();
          }).catch(error => {
            this.snackbar = true;
            this.snackbarText = 'Ошибка при создании улицы';
            this.snackbarColor = 'error';
          }).finally(() => {
            this.loadingButton = false
          })
      },
      getData() {
          let formData = new FormData();
          let time = moment('2020-01-01 ' + this.street.default_delivery_time).format('HH:mm:ss')

        formData.append('id', this.id);
          formData.append('name', this.street.name);
          formData.append('name_ua', this.street.name_ua);
          formData.append('area_id', this.street.area ? this.street.area.id : null);

          return formData;
      }
    },
  }
</script>

<style scoped lang="scss">
  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
  .street-images .v-image{
    max-height: 374px;
  }
  .street{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
